<template>
	<a
		class="button button-primary button__icon"
		:href="$data.base_href + $props.add_query"
		download
		:title="$data.buttonTitle"
		data-test-id="export-excel"
		@click="$emit('started')"
	>
		{{ buttonText }}
		<svg width="13" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M15 2H3V16H15V2ZM10.5458 12.4286H12.4286L10.0002 8.91158L12.3002 5.57143H10.5458L9.06953 7.88989H9.03744L7.58257 5.57143H5.6891L7.96768 8.88211L5.57143 12.4286H7.32583L8.89837 9.90381H8.93047L10.5458 12.4286Z" fill="white"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M2 1H14V0H1V15H2V1Z" fill="white"/>
		</svg>
	</a>
</template>

<script>
	/**
	 * Компонент, рисующий кнопку экспорта в excel: armMeta.exportListToExcel
	 */
	import urlUtil from '../../util-url.js'

	export default {
		name: 'ExportExcel',
		props: {
			options: {
				required: true,
			},
			show_context: {
				required: true,
				type: String,
			},
			arm_id: {
				required: true,
				type: Number,
			},
			add_query: {
				required: false,
				type: String,
				default: '',
			},
		},
		data() {
			var opt = this.$props.options || {}; // {} для страховки: дело в том что если поля нет (АРМ создан до внедрения поля), то мы все равно рисуем кнопку
			var endpoint = opt.fieldsSource === 'LIST' ? 'excel-list' : 'excel-list-with_card'; // по умолчанию берём состав полей из карточки
			var base_href = urlUtil.getServiceUrl({
				methodName: 'export/' + endpoint,
				armId: this.$props.arm_id,
				vpId: this.$route.params.vpId,
				context: this.$props.show_context,
			});

			return {
				/** Тайтл кнопки */
				buttonTitle: 'Экспорт в Excel',
				/** Текст в самой кнопке */
				buttonText: opt.buttonName || '',
				base_href,
			}
		}
	}
</script>
